/** Live "on the job today" widget — reads /orgs/{id}/on-the-job. */
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function OnTheJobPanel({ org }) {
  const [data, setData] = useState({ count: 0, members: [], by_dept: {}, members_total: 0 });

  useEffect(() => {
    if (!org?.id) return;
    api.get(`/orgs/${org.id}/on-the-job`)
       .then(({ data }) => setData(data))
       .catch((err) => console.warn("[OnTheJobPanel] load skipped:", err?.message));
  }, [org?.id]);

  if (!org) return null;
  const total = data.members_total || 0;

  return (
    <div className="mt-4 cs-card rounded-2xl p-5" data-testid="on-the-job-card">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[10px] tracking-[0.28em] uppercase text-white/55">On The Job Today</div>
          <div className="flex items-baseline gap-3 mt-1">
            <span className="font-display text-4xl" style={{ color: "#10B981" }}>{data.count || 0}</span>
            <span className="text-sm text-white/55">of {total.toLocaleString()} members working</span>
          </div>
        </div>
        {Object.keys(data.by_dept || {}).length > 0 && (
          <div className="flex flex-wrap gap-2 max-w-md justify-end">
            {Object.entries(data.by_dept).map(([d, n]) => (
              <span key={d}
                className="px-2 py-0.5 rounded-full text-[10px] tracking-[0.18em] uppercase bg-emerald-500/10 text-emerald-300 border border-emerald-500/20">
                {d} · {n}
              </span>
            ))}
          </div>
        )}
      </div>
      {(data.count || 0) > 0 && (
        <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-2.5" data-testid="on-the-job-list">
          {(data.members || []).slice(0, 9).map((m) => (
            <div key={m.user_id}
                 className="flex items-center gap-2.5 p-2 rounded-lg bg-emerald-500/5 border border-emerald-500/15"
                 data-testid={`on-the-job-${m.user_id}`}>
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              {m.avatar_url
                ? <img src={m.avatar_url} className="w-7 h-7 rounded-full" alt="" />
                : <div className="w-7 h-7 rounded-full bg-white/10" />}
              <div className="flex-1 min-w-0">
                <div className="text-xs font-semibold text-white truncate">{m.name}</div>
                <div className="text-[10px] text-white/55 truncate">{m.role_label} · {m.project_title}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
